import React from 'react';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import './App.css';
import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider } from './contexts/AuthContext';
import { ADMIN_BASE } from './lib/api';
import { initAnalytics, trackPageView } from './lib/analytics';
import { initAffirm } from './lib/bnpl';
import Nav from './components/Nav';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';
import Landing from './pages/Landing';
import Shop from './pages/Shop';
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import AdminProducts from './pages/admin/AdminProducts';
import AdminProductForm from './pages/admin/AdminProductForm';
import AdminOrders from './pages/admin/AdminOrders';
import AdminBanners from './pages/admin/AdminBanners';
import AdminSettings from './pages/admin/AdminSettings';

function PublicChrome({ children }) {
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith(ADMIN_BASE);

  // Init analytics once; init affirm.js lazily (resolves/rejects quietly).
  React.useEffect(() => {
    initAnalytics();
    initAffirm().catch(() => { /* buttons will hide themselves */ });
  }, []);
  React.useEffect(() => {
    if (!isAdmin) trackPageView(loc.pathname + loc.search);
  }, [loc.pathname, loc.search, isAdmin]);
  React.useEffect(() => {
    if (!isAdmin) return;
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => meta.remove();
  }, [isAdmin]);

  return (
    <>
      {!isAdmin && <Nav />}
      {children}
      {!isAdmin && <Footer />}
      {!isAdmin && <WhatsAppFloat />}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <PublicChrome>
            <Routes>
              {/* Public catalog (no cart / checkout) */}
              <Route path="/" element={<Landing />} />
              <Route path="/shop" element={<Shop />} />
              {/* Legacy routes → shop */}
              <Route path="/shop/:category" element={<Navigate to="/shop" replace />} />
              <Route path="/product/:id" element={<Navigate to="/shop" replace />} />

              {/* Admin */}
              <Route path={`${ADMIN_BASE}/login`} element={<AdminLogin />} />
              <Route path={ADMIN_BASE} element={<AdminLayout />}>
                <Route index element={<AdminProducts />} />
                <Route path="products/new" element={<AdminProductForm />} />
                <Route path="products/:id/edit" element={<AdminProductForm />} />
                <Route path="orders" element={<AdminOrders />} />
                <Route path="banners" element={<AdminBanners />} />
                <Route path="settings" element={<AdminSettings />} />
              </Route>
            </Routes>
          </PublicChrome>
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
